// Toasts
export const SET_MESSAGES = 'TOASTER_SET_MESSAGES'
export const ADD_TOAST = 'TOASTER_ADD_TOAST'
export const ADD_ERROR = 'TOASTER_ADD_ERROR'
export const ADD_WARNING = 'TOASTER_ADD_WARNING'
export const ADD_SUCCESS = 'TOASTER_ADD_SUCCESS'
export const ADD_INFO = 'TOASTER_ADD_INFO'
export const ADD_MESSAGE = 'TOASTER_ADD_MESSGAE'
export const REMOVE_TOAST = 'TOASTER_REMOVE_TOAST'
export const REMOVE_TOASTS = 'TOASTER_REMOVE_TOASTS'
export const SEVERITY_ERROR = 'TOASTER_SEVERITY_ERROR'
export const SEVERITY_WARNING = 'TOASTER_SEVERITY_WARNING'
export const SEVERITY_SUCCESS = 'TOASTER_SEVERITY_SUCCESS'
export const SEVERITY_INFO = 'TOASTER_SEVERITY_INFO'
export const RESHOW_NEWEST_MOTD = 'TOASTER_TOASTS_RESHOW_NEWEST_MOTD'
export const MOTDS_CHANGED = 'TOASTER_TOASTS_MOTDS_CHANGED'



// WEBPACK FOOTER //
// ./src/features/Toaster/data/toasts/constants.js